module.exports = __webpack_public_path__ + "static/media/arrow-white.min.4a8e087e.svg";